// Checkout-conflict contracts from POST /subscription/checkout, used by the
// Pricing checkout error branch.
//
// Contracts honored (key off `code`, never the human string):
//  - 409 { code: 'ACTIVE_SUBSCRIPTION_EXISTS', message }
//  - 409 { code: 'CHECKOUT_IN_PROGRESS', message }
//      Render `message` verbatim.

export const ACTIVE_SUBSCRIPTION_EXISTS = 'ACTIVE_SUBSCRIPTION_EXISTS';
export const CHECKOUT_IN_PROGRESS = 'CHECKOUT_IN_PROGRESS';

// Returns the backend's message for a checkout-conflict response, or null
// when the response is not one, so callers can fall back to their existing
// generic error handling.
export function checkoutConflictMessage(data: any): string | null {
  const code = data?.code;
  if (code !== ACTIVE_SUBSCRIPTION_EXISTS && code !== CHECKOUT_IN_PROGRESS) return null;
  return typeof data.message === 'string' && data.message ? data.message : null;
}
